import { render, staticRenderFns } from "./UserInfoPC.vue?vue&type=template&id=145a1f95&scoped=true"
import script from "./UserInfoPC.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInfoPC.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserInfoPC.vue?vue&type=style&index=0&id=145a1f95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145a1f95",
  null
  
)

export default component.exports